import {LitElement, html, customElement, property} from "lit-element";
import OcArLoading from "./oc-ar-loading";
import OcArQr from "./oc-ar-qr";
import OCArScreen from "./oc-ar-screen";
import "oc-threejs/ar/BufferGeometryToIndexed";

import DeviceDetection from "oc-commons/DeviceDetection";

// TODO:
// * Komponente muss mehrmals auf Seite erscheinen können, problematisch bei Loading over QR

class OcAr extends LitElement {
    deviceFunction = Function;
    loadingTimer = 0;
    minLoadingScreenMs = 3000;

    static get properties() {
        return {
            // Title für AR Viewer (Am Smartphone im AR-Viewer - ARCore - sichtbar)
            arTitle: {type: String},
            // Funktion zum Speichern der aktuellen Konfiguration, nötig für "Speicherplatz" der Daten für AR:
            //   ar.save = (onSuccess) => {
            //     APP.save({
            //         callback: (configuration) => {
            //             ar.configuration = configuration.Code;
            //             onSuccess(configuration);
            //         }
            //         , quiet: true,
            //         , preferUpdate: true,
            //         , noFotoSnapshots: true
            //     });
            //  };
            save: {type: Object},
            // Umfangreiches Objekt, für Parameter siehe AbstractApp augmentedReality()
            augmentedReality: {type: Object/* , hasChanged: (oldValue, newValue) => {
                debugger;
            } */},
            // Konfigurationscode
            configuration: {type: String},
            // Wenn diese Werte gesetzt sind, verhält sich die Komponente statisch, d.h. kein Speichern etc. mehr nötig, sondern direktes Laden dieser GLB bzw. USDZ Daten
            glbSrc: {type: String},
            usdzSrc: {type: String},
            buyButton: {type: Object},
            isLoadingFlag: {type: Boolean},
            QR: {type: Object},
        };
    }

    set loading(bool) {
        document.getElementById("ocarloading").active = bool;
    }

    set qr(bool) {
        document.getElementById("ocarqr").active = bool;
    }

    set arScreen(bool) {
        // ShadowRoot here because this func is called before appending to body
        this.shadowRoot.getElementById("ocarscreen").active = bool;
    }



    render() {
        return html`
            <slot id="slot" name="icon" @click=${() => this.start()}></slot>

            <!-- All some special Popup Screen Features. Will be appended to Body -->
            <oc-ar-loading id="ocarloading"></oc-ar-loading>
            <oc-ar-qr id="ocarqr" code=${this.configuration}></oc-ar-qr>
            <oc-ar-screen id="ocarscreen" .ocar=${this}>
            </oc-ar-screen>
        `;
    }

    updated() {
        // When QR Code is calling the instant AR Screen
        if (location.href.includes("#openAR=true")) {
            if (typeof window.history.replaceState == "function") {
                window.history.replaceState(
                    {},
                    "",
                    location.href.slice(0, location.href.indexOf("openAR=true") - 1)
                );
                this.arScreen = true;
            }
        }
    }

    start() {
        if (!this.save) {
            throw new Error("MISSING PARAMETERS FOR AR COMPONENT");
        }
        if (location.protocol != "https:") {
            console.warn("AR doesnt work here. Need HTTPS.");
        }
        // Loading Screen
        if (DeviceDetection.isAndroid() || DeviceDetection.isIOS()) {
            this.loading = true;
            this.loadingTimer = performance.now();
        }

        this.processParameters();

        // Wenn nötig erst Speichern
        if (this.configuration) {
            this.processAndUpdate();
        } else {
            this.save(
                ((configuration) => {
                    this.configuration = configuration;
                    this.processAndUpdate();
                }).bind(this),
                () => (this.loading = false)
            );
        }
    }

    processParameters() {
        if (DeviceDetection.isIOS()) {
            this.augmentedReality.convertToUSDZ = true;
            this.augmentedReality.ARUvMapping = true;
        }
    }

    getDevice() {
        if (DeviceDetection.isAndroid()) return "android";
        if (DeviceDetection.isIOS()) return "ios";
        return "unclear";
    }

    processAndUpdate() {
        if (this.glbSrc || this.usdzSrc || this.device === "unclear") {
            this.ar(this.configuration);
        } else {
            // extend incomming ar.before function with default indexing
            this.augmentedReality.before = ((old) => {
                return function (o3) {
                    o3.traverse((o3) => {
                        if (
                            o3.geometry &&
                            o3.geometry instanceof THREE.BufferGeometry &&
                            !o3.geometry.index
                        ) {
                            o3.geometry = o3.geometry.toIndexed();
                        }
                    });
                    if (old) old(o3);
                };
            })(this.augmentedReality.before);
            this.augmentedReality.code = this.configuration;
            APP.augmentedReality(this.augmentedReality).then(() => {
                this.ar();
            });
        }
    }

    ar() {
        let dif;
        if (DeviceDetection.isIOS()) {
            dif = performance.now() - this.loadingTimer;
            setTimeout(
                (code) => {
                    this.iosAR(code);
                },
                Math.max(this.minLoadingScreenMs - dif, 0),
                this.configuration
            );
        } else if (DeviceDetection.isAndroid()) {
            dif = performance.now() - this.loadingTimer;
            setTimeout(
                (code) => {
                    this.androidAR(code);
                },
                Math.max(this.minLoadingScreenMs - dif, 0),
                this.configuration
            );
        } else {
            this.qr = true;
        }
    }

    iosAR(code) {
        const anchor = document.createElement("a");
        anchor.setAttribute("rel", "ar");
        anchor.appendChild(document.createElement("img"));
        let usdzSrc = this.usdzSrc
            ? this.usdzSrc
            : APP.settings.wkfgContentBaseUrl + "Konfiguration/" + code + "/ios.usdz";
        console.log(usdzSrc, this.usdzSrc, code);
        if (code === '') {
            debugger;
        }
        if (this.buyButton) {
            let buyButtonUrl = "";
            if (this.buyButton.callToActionText) {
                buyButtonUrl = `${buyButtonUrl}${buyButtonUrl === "" ? "#" : "&"}callToAction=${encodeURIComponent(this.buyButton.callToActionText)}`;
            }
            if (this.buyButton.checkoutTitleText) {
                buyButtonUrl = `${buyButtonUrl}${buyButtonUrl === "" ? "#" : "&"}checkoutTitle=${encodeURIComponent(this.buyButton.checkoutTitleText)}`;
            }
            if (this.buyButton.checkoutSubtitleText) {
                buyButtonUrl = `${buyButtonUrl}${buyButtonUrl === "" ? "#" : "&"}checkoutSubtitle=${encodeURIComponent(this.buyButton.checkoutSubtitleText)}`;
            }
            if (this.buyButton.priceText) {
                buyButtonUrl = `${buyButtonUrl}${buyButtonUrl === "" ? "#" : "&"}price=${encodeURIComponent(this.buyButton.priceText)}`;
            }
            usdzSrc = usdzSrc + buyButtonUrl;
            if (this.buyButton.checkoutAction) {
                anchor.addEventListener("message", function (event) {
                    if (event.data == "_apple_ar_quicklook_button_tapped") {
                        this.buyButton.checkoutAction();
                    }
                }, false);
            }
            anchor.setAttribute("id", "ios-ar-link");
        }
        anchor.setAttribute("href", usdzSrc);
        //console.log("usdzSrc", this.buyButton, usdzSrc, anchor);
        anchor.click();
        this.loading = false;
    }

    async androidAR(code) {
        // Ausführung erst unten: Google cached!
        const ar = (index) => {
            const anchor = document.createElement("a");

            let gltfSrc = this.glbSrc
                ? this.glbSrc
                : APP.settings.wkfgContentBaseUrl +
                  "Konfiguration/" +
                  code +
                  "/ar" +
                  (index - 1) +
                  ".glb";
            gltfSrc = gltfSrc?.replace("?", "&");

            let fallbackInvoked = false;
            const location = self.location.toString();
            const locationUrl = new URL(location);
            const modelUrl = new URL(gltfSrc);
            const noArViewerSigil = "#model-viewer-no-ar-fallback";

            locationUrl.hash = noArViewerSigil;

            // &mode=ar_only
            let intentParams = `?file=${modelUrl.toString()}&mode=ar_preferred`;
            if (!gltfSrc.includes("&link=")) {
                intentParams += `&link=${encodeURIComponent(location)}`;
            }
            if (!gltfSrc.includes("&title=")) {
                intentParams += `&title=${encodeURIComponent(this.arTitle || "")}`;
            }

            const intent = `intent://arvr.google.com/scene-viewer/1.0${intentParams}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(
                locationUrl.toString()
            )};end;`;

            // const intent = "intent://arvr.google.com/scene-viewer/1.0?file=https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/master/2.0/Avocado/glTF/Avocado.gltf#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;"

            // const intent = "intent://arvr.google.com/scene-viewer/1.0?file=https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/master/2.0/Avocado/glTF/Avocado.gltf#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;"

            console.log("ANDROID AR INTENT CALLING! " + intent);

            anchor.setAttribute("href", intent);
            anchor.click();

            // make sure loading screen doesnt bug because system load
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        };

        if (!this.glbSrc) {
            const index = await APP.getNextArFileIndex(code);
            ar(index);
        } else {
            ar(0);
        }
    }
}

customElements.define("oc-ar", OcAr);
